export enum SimpleDialogCloseType {
  ACCEPT = "accept",
  CANCEL = "cancel",
}
